import { method } from 'lodash';
import template from './index.pug';

export default {
  name: 'DetailsRouteValenbici',
  template: template(),
  props: {
    directionsStopsBike: {
      type: String,
      required: true
    },
    bikesAvailable: {
      type: Number,
      required: true
    },
    spacesAvailableBike: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      positionStyle: {
        top: '0px',
        left: '0px',
        position: 'absolute',
      },
    };
  },
  methods: {
    /**
   * Permite actualizar la posición del tooltip en caso de que se necesite.
   * @param {Number} x - Coordenada X (en píxeles)
   * @param {Number} y - Coordenada Y (en píxeles)
   */
    updatePosition(x, y) {
      this.positionStyle.top = `${y + 10}px`;
      this.positionStyle.left = `${x - 100 }px`;
    },
  }
 
}